module.exports = __webpack_public_path__ + "static/media/scott-graham-OQMZwNd3ThU-unsplash.2f046273.jpg";